
import { getSearchBarOptions } from "./search-bar.js"
import { submit as dynamicSearchSubmit } from "./dynamic-search.js"
import { positionPickerPanel, updateUrlSearchParams } from "./pickers-init.js"
import { generateGuid } from "./pickers-init.js";
import { lockout } from "./utilities.js";
import Mustache from "./mustache.js";
import "./dayjs.min.js"

// The order of these const and let is bit disorganised unfortunately due to lexical declaration ordering.
const $pickerBlock = $('#form-searchblock');
const dayJsIsToday = (date) => {
	const mask = "YYYY-MM-DD";
	return dayjs().format(mask) === dayjs(date).format(mask)
}

const dayJsRange = (from, to, format) => {
	const list = [];
	let current = dayjs(from);

	while (current.isBefore(dayjs(to))) {
		list.push(format ? current.format(format) : current.format())
		current = current.add(1, 'day')
	}

	return list
}
dayjs.Ls.en.weekStart = 1;

let prevFocus;
let tmpDate = '';
let availableDates = [];
let firstMonth = new Date();
let secondMonth = dayjs(firstMonth).add(1, 'month');
let availableMonths = [];
let monthsHaveBeenSet = false;
let holidayStartDate = getSelectedDateValue();
let activeDates = [];

const activeClass = 'is-active';
const $datePicker = $pickerBlock.find('.c-date-picker');
const $datePickerTrigger = $pickerBlock.find('.js-date-picker-trigger');
const isSearchResultsPage = $pickerBlock.hasClass('js-dynamic-search');
const container = $('.js-date-picker-placeholder') //TODO
const formInputsIdSuffix = generateGuid();

const folksSelectorDurationInputValue = $pickerBlock.find('input[name="nights"]').val();
let lengthOfHoliday = parseInt(folksSelectorDurationInputValue) || 7;
let holidayLengthAnySelected = !folksSelectorDurationInputValue;
let holidayLength7Selected = lengthOfHoliday === 7;
let holidayLength14Selected = lengthOfHoliday === 14;
let holidayLength21Selected = lengthOfHoliday === 21;

const panelIsOpen = () => $pickerBlock.find('.c-date-picker').hasClass(activeClass);
const closeAllPanels = () => {
	$pickerBlock.find('.c-pickers-panel').removeClass(activeClass);
	$pickerBlock.find('.js-date-picker-wrapper, .js-folks-selector-trigger, .js-airport-picker-trigger, .js-destination-picker-trigger').removeClass(activeClass);
}
const getValueOfFlexibleDates = () => $pickerBlock.find('input[name="flexibleOnDates"]').val().toLowerCase() === 'true';

const getCurrentDateValues = () => {
	let dateValues = $pickerBlock.find('input[name="departuredateuk"]').val();
	$pickerBlock.find('.c-date-picker').find('input:checked, option:selected').each(function() {
		dateValues += `|${$(this).val()}`
	})

	return dateValues;
}

const haveSearchValuesChanged = () => getCurrentDateValues() !== tmpDate

/*
 * The date needs to be formatted so that JavaScript dates don't switch days and months
 */
function getSelectedDateValue() {
	var value = $pickerBlock.find('input[name="departuredateuk"]').val();
	if (!value) {
		return;
	}

	if (dayjs().isBefore(value) && !dayJsIsToday(value)) {
		return;
	}

	// dd/mm/yyyy
	var splitDate = value.split('/');
	var formatted = splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
	return formatted;
}

function setData(isInitial) {
	if (holidayStartDate) {
		activeDates = [];

		if (!holidayLengthAnySelected) {
			activeDates = dayJsRange(holidayStartDate, dayjs(holidayStartDate).add(lengthOfHoliday, 'days'));
		}

		// only do on first open
		if (isInitial) {
			firstMonth = holidayStartDate;
			secondMonth = dayjs(holidayStartDate).add(1, 'month').startOf('month');
		}
	}

	calculateAvailableDates();

	const viewData = {
		firstMonthTitle: dayjs(firstMonth).format('MMMM YYYY'),
		daysInMonthOne: getDaysInMonth(dayjs(firstMonth).startOf('month'), dayjs(firstMonth).endOf('month')),
		secondMonthTitle: dayjs(secondMonth).format('MMMM YYYY'),
		daysInMonthTwo: getDaysInMonth(dayjs(secondMonth).startOf('month'), dayjs(secondMonth).endOf('month')),
		showMonthTwo: shouldShowMonthTwo(),
		availableMonths,
		formInputsIdSuffix,
		holidayLengthAnySelected,
		holidayLength7Selected,
		holidayLength14Selected,
		holidayLength21Selected,
		flexibleDatesIsChecked: getValueOfFlexibleDates(),
		searchFlexibleDatesExpansionNumber: 3
	};

	// TODO ST-4727
	// This ripping out the whole container html and replacing, then showing the whole panel again is very wrong, the only content that needs to change is the calendars
	const localIsOpen = panelIsOpen()// Get value now before container.html() detroys it
	const template = Mustache.render($('#datePickerTemplate').html(), viewData);
	container.html(template);
	if (localIsOpen) {
		// if panel was open before, then open it again
		positionPickerPanel($pickerBlock, $datePickerTrigger)
		$pickerBlock.find('.c-date-picker, .js-date-picker-wrapper').addClass(activeClass);
	}
}

function shouldShowMonthTwo() {
	const lastMonth = availableMonths[availableMonths.length - 1];
	if (!lastMonth) {
		return true;
	}

	if (dayjs(secondMonth).isAfter(lastMonth.value, 'month')) {
		return false;
	}

	return true;
}

function calculateAvailableDates() {
	const availableMonthsToSet = [];
	try {
		const seasonMonths = window.seasonmonths.CurrentAndFutureSeasonMonths;

		if (!monthsHaveBeenSet) {
			firstMonth = holidayStartDate ? holidayStartDate : seasonMonths[0];
			secondMonth = getSecondMonth(firstMonth);
		}

		for (let i = 0; i < seasonMonths.length; i++) {
			const monthDate = dayjs(seasonMonths[i]).toDate();
			availableMonthsToSet.push({
				text: dayjs(monthDate).format('MMMM YYYY'),
				value: monthDate,
				selected: dayjs(monthDate).isSame(firstMonth, 'month')
			});
		}

		availableMonths = availableMonthsToSet;
		monthsHaveBeenSet = true;
	}
	catch (e) {
		console.log(`calculateAvailableDates failed try/catch`, e);
	}
}

function getSecondMonth(firstMonth) {
	const seasonMonths = window.seasonmonths.CurrentAndFutureSeasonMonths;
	const startofMonth = (month) => dayjs(month).startOf('month');

	for (let i = 0, len = seasonMonths.length; i < len; i++) {
		const currentMonth = seasonMonths[i];

		if (dayjs(startofMonth(firstMonth)).isSame(startofMonth(currentMonth))) {
			if (seasonMonths[i + 1]) {
				return dayjs(seasonMonths[i + 1]).startOf('month');
			}
		}
	}

	return dayjs(firstMonth).add(1, 'month').startOf('month').toDate();
}

function setSelectedIndexOfMonthSelect(index) {
	container.find('.js-date-picker-month-selector option').eq(index).prop('selected', true);
	container.find('.js-date-picker-month-selector').trigger('change'); //Change event prompts the calender to update - jqueryUI
}

function getDaysInMonth(startDate, endDate) {
	const isMonday = dayjs(startDate).format('ddd') === 'Mon';
	const isWeekend = (date) => {
		const weekendDay = dayjs(date).format('ddd');
		return weekendDay === 'Sun' || weekendDay === 'Sat';
	}

	const daysInMonth = dayJsRange(startDate, endDate);
	const daysPossiblyInTheMonthBefore = isMonday ? [] : dayJsRange(dayjs(startDate).startOf('week'), dayjs(startDate));
	const possibleDays = daysPossiblyInTheMonthBefore.concat(daysInMonth);
	const formatted = possibleDays.map(function(date) {
		return {
			date: date,
			text: dayjs(date).isBefore(startDate) ? '' : dayjs(date).format('D'),
			isDisabled: !isDateAvailable(date),
			isActive: isActiveDate(date),
			isWeekend: isWeekend(date),
			isStartDate: dayjs(date).isSame(holidayStartDate),
			showButton: !dayjs(date).isBefore(startDate)
		};
	});

	// split down into array of arrays for mustache
	const final = [];
	while (formatted.length) {
		final.push(formatted.splice(0, 7));
	}

	return final;
}

function isDateAvailable(date) {
	if (dayjs(date).isBefore(dayjs()) && !dayJsIsToday(date)) {
		return false;
	}

	for (var i = 0, len = availableDates.length; i < len; i++) {
		if (dayjs(availableDates[i]).isSame(date, 'day')) {
			return true;
		}
	}

	return false;
}

function isActiveDate(date) {
	for (var i = 0, len = activeDates.length; i < len; i++) {
		if (dayjs(activeDates[i]).isSame(date, 'day')) {
			return true;
		}
	}

	return false;
}

function setFacadeText() {
	if (!holidayStartDate) {
		return '';
	}

	let returningDate;
	let facadeText;
	const holidayStartDateDJS = dayjs(holidayStartDate);
	if (holidayLength7Selected) {
		returningDate = holidayStartDateDJS.add(7, 'day');
	}
	else if (holidayLength14Selected) {
		returningDate = holidayStartDateDJS.add(14, 'day');
	}
	else if (holidayLength21Selected) {
		returningDate = holidayStartDateDJS.add(21, 'day');
	}

	if (!returningDate) {
		facadeText = holidayStartDateDJS.format('DD/MM/YYYY');
	}
	else {
		facadeText = holidayStartDateDJS.format('DD/MM/YYYY') + ' → ' + dayjs(returningDate).format('DD/MM/YYYY');
	}

	$pickerBlock.find('.js-date-picker-input').val(facadeText);
}

function handleDateSelected(context) {
	if (context.hasClass('is-disabled')) {
		return;
	}

	holidayStartDate = context.attr('data-date');
	setFacadeText();
	$pickerBlock.find('input[name="departuredateuk"]').val(dayjs(holidayStartDate).format('DD/MM/YYYY'));
	activeDates = dayJsRange(holidayStartDate, dayjs(holidayStartDate).add(lengthOfHoliday + 1, 'days'));
	setData();
}

const removeCloseListener = (event) => {
	if (!event.target.closest('.js-date-picker-input, .c-date-picker')) {
		closeDatePicker();
	}
}

function openDatePicker() {
	prevFocus = document.activeElement;
	lockout.on('tablet')
	window.site.win.on('resize', () => {
		positionPickerPanel($pickerBlock, $datePickerTrigger)
	});
	positionPickerPanel($pickerBlock, $datePickerTrigger)
	$pickerBlock.find('.c-date-picker, .js-date-picker-wrapper').addClass(activeClass);
	$datePicker.find('select, button, [href], input, [tabindex]:not([tabindex="-1"]').first().focus();
	tmpDate = getCurrentDateValues()
	window.requestAnimationFrame(() => {
		window.site.body.on('click.date', (e) => removeCloseListener(e))
	})
}

function closeDatePicker() {
	if (haveSearchValuesChanged() && isSearchResultsPage) {
		getSearchBarOptions();
		updateUrlSearchParams()
		dynamicSearchSubmit(false);
	}

	$pickerBlock.find('.c-date-picker, .js-date-picker-wrapper').removeClass(activeClass);
	window.site.win.off('resize', () => {
		positionPickerPanel($pickerBlock, $datePickerTrigger)
	});

	window.site.body.off('click.date')
	lockout.off()
	prevFocus?.focus();
}

function attachEventListeners() {
	$datePickerTrigger.on('click keypress', function(e) {
		if (e.type === 'click' || ((e.type === 'keypress') && e.which === 13)) {

			// if datepicker already active close
			if (panelIsOpen()) {
				closeAllPanels()
				closeDatePicker()
				window.site.body.off('click.date', (e) => removeCloseListener(e))
			}
			else { // open if not
				closeAllPanels()
				openDatePicker()
				window.requestAnimationFrame(() => {
					window.site.body.on('click.date', (e) => removeCloseListener(e))
				})
			}

			e.preventDefault();
		}
	});

	$pickerBlock.on('click', '.js-date-picker-apply, .js-date-picker-close', function() {
		closeDatePicker();
	});

	$pickerBlock.on('click', '.js-date-picker-day', function() {
		handleDateSelected($(this));
	});

	$pickerBlock.on('change', '.js-date-picker-month-selector', function() {
		firstMonth = dayjs($(this).val()).startOf('month').toDate();
		secondMonth = getSecondMonth(firstMonth);
		setData();
	});

	$pickerBlock.on('change', '.js-date-picker-length-selector', function() {
		const $this = $(this)
		lengthOfHoliday = parseInt($this.val());
		holidayLength7Selected = $this.hasClass('js-date-picker-length-selector-7');
		holidayLength14Selected = $this.hasClass('js-date-picker-length-selector-14');
		holidayLength21Selected = $this.hasClass('js-date-picker-length-selector-21');
		holidayLengthAnySelected = $this.hasClass('js-date-picker-length-selector-any');
		$pickerBlock.find('input[name="nights"]').val(holidayLengthAnySelected ? '' : lengthOfHoliday);

		setData();

		if (holidayStartDate) {
			setFacadeText();
		}
	});

	$pickerBlock.on('click', '.js-date-picker-previous-month', function() {
		const currentMonthSelectedIndex = container.find('.js-date-picker-month-selector option:selected').index();
		if (currentMonthSelectedIndex !== 0) {
			setSelectedIndexOfMonthSelect(currentMonthSelectedIndex - 1);
		}
	});

	$pickerBlock.on('click', '.js-date-picker-next-month', function() {
		const currentMonthSelectedIndex = container.find('.js-date-picker-month-selector option:selected').index();
		setSelectedIndexOfMonthSelect(currentMonthSelectedIndex + 1);
	});

	$pickerBlock.on('change', '.js-date-picker-flexible-dates-checkbox', function() {
		$pickerBlock.find('input[name="flexibleOnDates"]').val($(this).is(':checked') ? 'True' : 'False');
	});

	window.site.body.on('availableDatesLoaded', function(data) {
		availableDates = data.availableDates;
		setData();
	});

	/* Do not trigger keyboard popup on iOS*/
	window.site.body.on('mousedown', '.js-folks-selector-departing', function(e) {
		e.preventDefault();
	});
}

const init = () => {
	setData(true);
	attachEventListeners();
	setFacadeText();
}

export default init;
